import { MembersList } from "./components/MembersList";

export function MembersPage() {
  return (
    <div className="p-4 sm:p-6">
      <MembersList />
    </div>
  );
}
